// utils/validateRegistrationForm.js
export const validateFormData = (formData) => {
  const errors = {};

  if (!formData.fullName.trim())
    errors.fullName = "Họ và tên không thể để trống";

  if (!formData.phone.trim()) {
    errors.phone = "Số điện thoại không thể để trống";
  } else if (!/^\d{10,11}$/.test(formData.phone)) {
    errors.phone = "Số điện thoại không hợp lệ (10-11 số)";
  }

  if (!formData.email.trim()) {
    errors.email = "Email không thể để trống";
  } else if (
    !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)
  ) {
    errors.email = "Email không hợp lệ";
  }

  if (!formData.programs.length)
    errors.programs = "Vui lòng chọn ít nhất một chương trình đào tạo";

  if (!formData.agreement)
    errors.agreement = "Bạn cần đồng ý với các điều khoản";

  if (formData.education === "Khác" && !formData.otherEducation.trim()) {
    errors.otherEducation = "Vui lòng nhập trình độ học vấn khác";
  }

  if (formData.source === "Khác" && !formData.otherSource.trim()) {
    errors.otherSource = "Vui lòng nhập nguồn thông tin khác";
  }

  return errors;
};
